const loadingLabel = "Učitavanje";
const hrHR = {
  loadingLabel
};
export {
  hrHR as default,
  loadingLabel
};
